var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 5,
    height: 4,
    fill: "#0071B6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    width: 5,
    height: 4,
    fill: "#0071B6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 5,
    height: 4,
    fill: "#0071B6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 5,
    height: 4,
    fill: "#0071B6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 5,
    height: 4,
    fill: "#0071B6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 5,
    height: 4,
    fill: "#0071B6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    fill: "#0071B6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 5,
    height: 4,
    fill: "#0071B6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 5,
    height: 4,
    fill: "#0071B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewIcon);
export default __webpack_public_path__ + "static/media/GridViewIcon.9a9a70a139e14b50fd958bb5081d5898.svg";
export { ForwardRef as ReactComponent };